import {DriveFile, isFolder} from '../drive/types';

/**
 * Plazma files keyed by name. A web photo counts as "in plazma" when a file with the same
 * name exists in the plazma bin — the naming convention makes names unique within an album,
 * and matching by name also recognises copies that were made by hand in Drive.
 */
export type PlazmaIndex = Map<string, DriveFile[]>;

export function buildPlazmaIndex(plazmaFiles: DriveFile[] | undefined): PlazmaIndex {
    const index: PlazmaIndex = new Map();
    for (const file of plazmaFiles ?? []) {
        if (isFolder(file)) continue;
        const copies = index.get(file.name);
        if (copies) copies.push(file); else index.set(file.name, [file]);
    }
    return index;
}

/** Every plazma copy of the given web files. */
export function findPlazmaCopies(index: PlazmaIndex, webFiles: DriveFile[]): DriveFile[] {
    return webFiles.flatMap((f) => index.get(f.name) ?? []);
}
